import firebase from "utils/auth/firebase";
import { jwtDecode } from "jwt-decode";
import { R2D2_CONTENT_KEY } from "constants/env";
import processor from "./processor";


export const processData = async (buffer) => {
    const token = await firebase?.auth()?.currentUser?.getIdToken?.();
    const decodedToken = jwtDecode(token);
    const i = generateIV16(decodedToken.auth_time + decodedToken.iat + decodedToken.exp);
    const k = Uint8Array.from(atob(R2D2_CONTENT_KEY), c => c.charCodeAt(0));
    const data = new Uint8Array(buffer);
    return await processor(k, i, data);
}

export const processContent = async (buffer) => {
    const resultBytes = new Uint8Array(await processData(buffer));
    return new TextDecoder().decode(resultBytes);
}

const generateIV16 = (number, byteLength = 16) => {
    const array = new Uint8Array(byteLength);
    for (let i = 1; i <= byteLength; i++) {
        array[byteLength - i] = number & 0xff;
        // Use division instead of bit shift
        // JavaScript's bitwise operations convert numbers to 32-bit integers,
        // which can lead to unexpected results with large numbers.
        number = Math.floor(number / 256);
    }
    return array;
}
